import { useCanEditQotd } from "../../commonComponents/EditQuoteOfTheDay/EditQuoteOfTheDay";

// The "edit" affordance next to the quote in the header. The modal lives in
// KryefaqjaHeader so the triple-click shortcut on the quote can open it too.
function EditQOTD({ onEdit }) {
  const canEdit = useCanEditQotd();

  if (!canEdit) return null;

  return (
    <span
      style={{ color: "grey", cursor: "pointer", marginLeft: "10px" }}
      onClick={onEdit}
    >
      edit
    </span>
  );
}

export default EditQOTD;
